<div style="text-align:center;padding-top:10px" *ngIf="pregnancyData.length == 0" translate>
    No Pregnancy data exists for student
</div>
<mat-table *ngIf="pregnancyData.length > 0" style="width: 100%;display: table;" #table [dataSource]="dataSource"
    matSort multiTemplateDataRows matSortDisableClear id="prgTable" matSortActive="DateOfTest"
    [matSortDirection]="defaultSorDirection" aria-label="Pregnancy Table">

    <ng-container matColumnDef="DateOfTest">
        <mat-header-cell *matHeaderCellDef mat-sort-header="DateOfTest">
            <span translate style="white-space:nowrap;">Date</span>
            <filter [data]="dataSource" columnName="DateOfTest" dataType="date" id="dateOfTestFilter"
                class="mat-filter">
            </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.DateOfTest|date:'MM/dd/yy'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DateExpecting">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate style="white-space:nowrap;">Expected</span>
            <filter [data]="dataSource" columnName="DateExpecting" dataType="date" id="dateExpectingFilter"
                class="mat-filter">
            </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.DateExpecting|date:'MM/dd/yy'}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="HospitalName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Hospital</span>
            <filter [data]="dataSource" columnName="HospitalName" dataType="string" id="hospitalsFilter"
                class="mat-filter">
            </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
            {{ element.HospitalName}}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="DateHomeTeachingStart">
        <mat-header-cell *matHeaderCellDef mat-sort-header="DateHomeTeachingStart">
            <span translate style="text-align: left;">Home Instruction Start</span>
            <filter [data]="dataSource" columnName="DateHomeTeachingStart" dataType="date" id="startDateFilter"
                class="mat-filter">
            </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.DateHomeTeachingStart|date:'MM/dd/yy'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DateHomeTeachingEnd">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate style="text-align: left;">Home Instruction End</span>
            <filter [data]="dataSource" columnName="DateHomeTeachingEnd" dataType="date" id="endDateFilter"
                class="mat-filter">
            </filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.DateHomeTeachingEnd|date:'MM/dd/yy'}}</mat-cell>
    </ng-container>
    
    <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="PRGHeader">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="prgDataRow{{i}}" tabindex="0"
        tabindex="0" matRipple>
    </mat-row>
</mat-table>